/* CPSO Golf Ball Customizer v1 (Oct 2026) */
(function () {
  'use strict';
  var root = document.getElementById('cpso-gbc');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var CFG = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
  var T = CFG.t;
  CFG.forceSide2 = /[?&]gbc_test=1/.test(location.search);
  $$('[data-t]', root).forEach(function (e) { if (T[e.dataset.t]) e.textContent = T[e.dataset.t]; });
  $$('[data-t-aria]', root).forEach(function (e) { if (T[e.dataset.tAria]) e.setAttribute('aria-label', T[e.dataset.tAria]); });
  var SIZE = 1000;
  var C = { x: 499.6, y: 499.5, r: 235 };      // printable circle (canvas px) = 21 mm on a 42.67 mm ball (BALL.r 478)
  var MM = 21 / (2 * C.r);                       // mm per canvas px
  var BALL = { x: 500, y: 500, r: 478 };
  var MAXCH = 17, MAXLINES = 3;
  var COLOURS = [
    ['Black', '#111111', T.c_black], ['Blue', '#0072ce', T.c_blue], ['Red', '#c8102e', T.c_red],
    ['Navy', '#1f2a44', T.c_navy], ['Green', '#00843d', T.c_green], ['Purple', '#6a2c91', T.c_purple],
    ['Pink', '#e8458b', T.c_pink], ['Gold', '#b8902f', T.c_gold]
  ];
  var TINTS = { yellow: '#f1ec4a', pink: '#f7b3cf', orange: '#ffa64d', green: '#a6e38f', red: '#f08a8a', blue: '#9cc7f2', purple: '#c9a6e8' };
  var FONT = '"Helvetica Neue", Helvetica, Arial, sans-serif';

  /* ---------- helpers ---------- */
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function h(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) { if (k === 'class') e.className = attrs[k]; else e.setAttribute(k, attrs[k]); }
    if (html != null) e.innerHTML = html;
    return e;
  }
  var seg = (window.Intl && Intl.Segmenter) ? new Intl.Segmenter(undefined, { granularity: 'grapheme' }) : null;
  function graphemes(s) { return seg ? Array.from(seg.segment(s), function (x) { return x.segment; }) : Array.from(s); }
  function clip17(s) { var g = graphemes(s); return g.length > MAXCH ? g.slice(0, MAXCH).join('') : s; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return CFG.money.replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2)); }

  /* ---------- state ---------- */
  var ballImg = new Image(); ballImg.crossOrigin = 'anonymous'; ballImg.src = CFG.ball;
  var S = {
    side: 1,
    s1: { type: 'logo', logo: null },
    s2: { type: 'none', logo: null, text: { lines: ['', '', ''], color: 'Black', s: 0.85, o: { x: 0, y: 0 } } },
    approved: null, dragging: false
  };

  /* ---------- background removal ---------- */
  function toCanvas(img, max) {
    var w = img.naturalWidth || img.width, hgt = img.naturalHeight || img.height;
    if (!w || !hgt) { w = 1000; hgt = 1000; }
    var k = Math.min(1, max / Math.max(w, hgt));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(hgt * k));
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c;
  }
  function hasTransparency(c) {
    var d = c.getContext('2d').getImageData(0, 0, c.width, c.height).data, n = 0, t = 0;
    for (var i = 3; i < d.length; i += 4 * 7) { n++; if (d[i] < 200) t++; }
    return t / n > 0.03;
  }
  function borderColour(d, w, hh) {
    var bins = {}, best = null, bestN = 0;
    function add(x, y) {
      var i = (y * w + x) * 4; if (d[i + 3] < 128) return;
      var key = (d[i] >> 4) + ',' + (d[i + 1] >> 4) + ',' + (d[i + 2] >> 4);
      var b = bins[key] || (bins[key] = { n: 0, r: 0, g: 0, b: 0 });
      b.n++; b.r += d[i]; b.g += d[i + 1]; b.b += d[i + 2];
      if (b.n > bestN) { bestN = b.n; best = b; }
    }
    for (var x = 0; x < w; x++) { add(x, 0); add(x, hh - 1); }
    for (var y = 0; y < hh; y++) { add(0, y); add(w - 1, y); }
    return best ? [best.r / best.n, best.g / best.n, best.b / best.n] : [255, 255, 255];
  }
  function removeBackground(src, tol, inside) {
    var w = src.width, hh = src.height;
    var out = document.createElement('canvas'); out.width = w; out.height = hh;
    var ctx = out.getContext('2d'); ctx.drawImage(src, 0, 0);
    var id = ctx.getImageData(0, 0, w, hh), d = id.data;
    var bg = borderColour(d, w, hh), orig = new Uint8ClampedArray(d);
    var N = w * hh, dist = new Float32Array(N), mark = new Uint8Array(N);
    for (var p = 0, i = 0; p < N; p++, i += 4) {
      var dr = d[i] - bg[0], dg = d[i + 1] - bg[1], db = d[i + 2] - bg[2];
      dist[p] = Math.sqrt(dr * dr + dg * dg + db * db);
    }
    var soft = tol * 1.9;
    if (inside) {
      for (p = 0; p < N; p++) if (dist[p] < soft) mark[p] = 1;
    } else {
      // flood fill from the edges over pixels close to the background colour
      var stack = new Int32Array(N), sp = 0;
      function push(q) { if (!mark[q] && dist[q] < soft) { mark[q] = 1; stack[sp++] = q; } }
      for (var x = 0; x < w; x++) { push(x); push((hh - 1) * w + x); }
      for (var y = 0; y < hh; y++) { push(y * w); push(y * w + w - 1); }
      while (sp) {
        var q = stack[--sp], qx = q % w;
        if (qx > 0) push(q - 1); if (qx < w - 1) push(q + 1);
        if (q >= w) push(q - w); if (q < N - w) push(q + w);
      }
    }
    for (p = 0, i = 0; p < N; p++, i += 4) {
      if (!mark[p]) continue;
      var dd = dist[p];
      if (dd <= tol) { d[i + 3] = 0; continue; }
      var a = (dd - tol) / (soft - tol); a = a < 0 ? 0 : a > 1 ? 1 : a;
      // un-mix the background colour from anti-aliased edge pixels
      for (var ch = 0; ch < 3; ch++) {
        var v = (d[i + ch] - bg[ch] * (1 - a)) / Math.max(a, 0.05);
        d[i + ch] = v < 0 ? 0 : v > 255 ? 255 : v;
      }
      d[i + 3] = Math.round(d[i + 3] * a);
    }
    despeckle(d, w, hh, orig);
    ctx.putImageData(id, 0, 0);
    return out;
  }
  // drop stray specks left behind by textured / noisy backgrounds so the trim hugs the real logo
  function despeckle(d, w, hh, orig) {
    var N = w * hh, lab = new Int32Array(N), stack = new Int32Array(N), areas = [0], p, i;
    for (p = 0; p < N; p++) lab[p] = d[p * 4 + 3] > 60 ? -1 : 0;
    var n = 0, big = 0;
    for (p = 0; p < N; p++) {
      if (lab[p] !== -1) continue;
      n++; var sp = 0, a = 0; lab[p] = n; stack[sp++] = p;
      while (sp) {
        var q = stack[--sp], qx = q % w; a++;
        if (qx > 0 && lab[q - 1] === -1) { lab[q - 1] = n; stack[sp++] = q - 1; }
        if (qx < w - 1 && lab[q + 1] === -1) { lab[q + 1] = n; stack[sp++] = q + 1; }
        if (q >= w && lab[q - w] === -1) { lab[q - w] = n; stack[sp++] = q - w; }
        if (q < N - w && lab[q + w] === -1) { lab[q + w] = n; stack[sp++] = q + w; }
      }
      areas.push(a); if (a > big) big = a;
    }
    if (!big) return;
    var minA = Math.max(24, Math.min(big * 0.004, N * 0.0004));
    var keep = new Uint8Array(N);
    for (p = 0; p < N; p++) if (lab[p] > 0 && areas[lab[p]] >= minA) keep[p] = 1;
    // allow faint anti-aliased edge pixels only right next to kept shapes (2px)
    var near = new Uint8Array(N), R = 2;
    for (var y = 0; y < hh; y++) for (var x = 0; x < w; x++) {
      if (!keep[y * w + x]) continue;
      for (var yy = Math.max(0, y - R); yy <= Math.min(hh - 1, y + R); yy++)
        for (var xx = Math.max(0, x - R); xx <= Math.min(w - 1, x + R); xx++) near[yy * w + xx] = 1;
    }
    for (p = 0, i = 3; p < N; p++, i += 4) if (!near[p]) d[i] = 0;
    if (!orig) return;
    // fill tiny pin-holes inside the logo (e.g. dark texture that matched the background colour)
    var hl = new Int32Array(N), holeMax = Math.max(16, minA), hid = 0;
    for (p = 0; p < N; p++) {
      if (hl[p] || keep[p]) continue;
      hid++; var sp2 = 0, cnt = 0, edge = false, list = [];
      hl[p] = hid; stack[sp2++] = p;
      while (sp2) {
        var r = stack[--sp2], rx = r % w; cnt++; if (cnt <= holeMax + 1) list.push(r);
        if (rx === 0 || rx === w - 1 || r < w || r >= N - w) edge = true;
        if (rx > 0 && !hl[r - 1] && !keep[r - 1]) { hl[r - 1] = hid; stack[sp2++] = r - 1; }
        if (rx < w - 1 && !hl[r + 1] && !keep[r + 1]) { hl[r + 1] = hid; stack[sp2++] = r + 1; }
        if (r >= w && !hl[r - w] && !keep[r - w]) { hl[r - w] = hid; stack[sp2++] = r - w; }
        if (r < N - w && !hl[r + w] && !keep[r + w]) { hl[r + w] = hid; stack[sp2++] = r + w; }
      }
      if (!edge && cnt <= holeMax) for (var k = 0; k < list.length; k++) {
        var j = list[k] * 4; d[j] = orig[j]; d[j + 1] = orig[j + 1]; d[j + 2] = orig[j + 2]; d[j + 3] = orig[j + 3];
      }
    }
  }
  function trim(c) {
    var w = c.width, hh = c.height, d = c.getContext('2d').getImageData(0, 0, w, hh).data;
    var x0 = w, y0 = hh, x1 = -1, y1 = -1;
    for (var y = 0; y < hh; y++) for (var x = 0; x < w; x++) {
      if (d[(y * w + x) * 4 + 3] > 12) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return null;
    var o = document.createElement('canvas'); o.width = x1 - x0 + 1; o.height = y1 - y0 + 1;
    o.getContext('2d').drawImage(c, -x0, -y0);
    return o;
  }
  // outline points (left/right-most opaque pixel per row) used to keep the logo inside the circle
  function outline(c) {
    var w = c.width, hh = c.height, d = c.getContext('2d').getImageData(0, 0, w, hh).data, pts = [];
    var step = Math.max(1, Math.floor(hh / 160));
    for (var y = 0; y < hh; y += step) {
      var l = -1, r = -1;
      for (var x = 0; x < w; x++) if (d[(y * w + x) * 4 + 3] > 12) { if (l < 0) l = x; r = x; }
      if (l >= 0) { pts.push({ x: l - w / 2, y: y - hh / 2 }); pts.push({ x: r + 1 - w / 2, y: y - hh / 2 }); }
    }
    for (var x2 = 0; x2 < w; x2 += Math.max(1, Math.floor(w / 80))) {
      // top & bottom-most per column
      var t = -1, b = -1;
      for (var y2 = 0; y2 < hh; y2++) if (d[(y2 * w + x2) * 4 + 3] > 12) { if (t < 0) t = y2; b = y2; }
      if (t >= 0) { pts.push({ x: x2 - w / 2, y: t - hh / 2 }); pts.push({ x: x2 - w / 2, y: b + 1 - hh / 2 }); }
    }
    return pts;
  }
  function kmaxOf(pts) { var m = 1; pts.forEach(function (p) { var r = Math.hypot(p.x, p.y); if (r > m) m = r; }); return C.r / m; }

  function buildLogo(L) {
    var trans = hasTransparency(L.base);
    L.wasTransparent = trans;
    var c = L.base;
    if (L.removeBg && !trans) c = removeBackground(L.base, L.tol, L.inside);
    var t = trim(c) || trim(L.base) || L.base;
    L.draw = t; L.pts = outline(t); L.kmax = kmaxOf(L.pts);
    L.o = clampOffset(L, L.s, L.o);
  }
  function loadLogo(file, cb) {
    if (!file) return;
    if (!/^image\//.test(file.type) || /tiff|heic|heif/.test(file.type)) { toast(T.err_type); return; }
    if (file.size > 20 * 1024 * 1024) { toast(T.err_size); return; }
    var url = URL.createObjectURL(file), img = new Image();
    img.onload = function () {
      var L = { file: file, base: toCanvas(img, 1400), removeBg: true, tol: 40, inside: true, s: 0.8, o: { x: 0, y: 0 } };
      try { buildLogo(L); } catch (e) { toast(T.err_read); return; }
      cb(L);
    };
    img.onerror = function () { toast(T.err_read); };
    img.src = url;
  }

  /* ---------- text layer ---------- */
  var mctx = document.createElement('canvas').getContext('2d');
  function textLines(tx) { return tx.lines.map(function (s) { return s.trim(); }).filter(Boolean); }
  function textGeom(tx) {
    var lines = textLines(tx), fs = 100, lh = 118;
    mctx.font = '800 ' + fs + 'px ' + FONT;
    var H = lines.length * lh, pts = [], rows = [];
    lines.forEach(function (s, i) {
      var w = Math.max(10, mctx.measureText(s).width), cy = -H / 2 + lh * i + lh / 2;
      var top = cy - fs * 0.42, bot = cy + fs * 0.42;
      rows.push({ s: s, y: cy });
      pts.push({ x: -w / 2, y: top }, { x: w / 2, y: top }, { x: -w / 2, y: bot }, { x: w / 2, y: bot });
    });
    return { rows: rows, pts: pts, fs: fs };
  }
  function syncText() {
    var tx = S.s2.text, g = textGeom(tx);
    tx.g = g; tx.pts = g.pts; tx.kmax = g.pts.length ? kmaxOf(g.pts) : 1;
    tx.o = clampOffset(tx, tx.s, tx.o);
  }

  /* ---------- fit / clamp ---------- */
  function fits(L, s, o) {
    var k = s * L.kmax, R2 = (C.r + 0.5) * (C.r + 0.5);
    for (var i = 0; i < L.pts.length; i++) {
      var x = k * L.pts[i].x + o.x, y = k * L.pts[i].y + o.y;
      if (x * x + y * y > R2) return false;
    }
    return true;
  }
  function clampOffset(L, s, o) {
    if (!L.pts || !L.pts.length) return { x: 0, y: 0 };
    if (fits(L, s, o)) return o;
    if (!fits(L, s, { x: 0, y: 0 })) return { x: 0, y: 0 };
    var lo = 0, hi = 1;
    for (var i = 0; i < 22; i++) { var m = (lo + hi) / 2; if (fits(L, s, { x: o.x * m, y: o.y * m })) lo = m; else hi = m; }
    return { x: o.x * lo, y: o.y * lo };
  }
  function moveTo(L, o, prev) {
    if (fits(L, L.s, o)) return o;
    // try to slide along the edge
    var a = { x: o.x, y: prev.y }, b = { x: prev.x, y: o.y };
    if (fits(L, L.s, a)) return a;
    if (fits(L, L.s, b)) return b;
    return clampOffset(L, L.s, o);
  }
  function activeLayer() {
    if (S.side === 1) return S.s1.logo;
    if (S.s2.type === 'logo') return S.s2.logo;
    if (S.s2.type === 'text' && textLines(S.s2.text).length) return S.s2.text;
    return null;
  }

  /* ---------- drawing ---------- */
  function ballTint() {
    var v = (currentBallColour() || '').toLowerCase();
    for (var k in TINTS) if (v.indexOf(k) > -1) return TINTS[k];
    return null;
  }
  var layerCanvas = document.createElement('canvas'); layerCanvas.width = SIZE; layerCanvas.height = SIZE;
  function drawSide(ctx, side, guides) {
    ctx.clearRect(0, 0, SIZE, SIZE);
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, SIZE, SIZE);
    if (ballImg.complete && ballImg.naturalWidth) ctx.drawImage(ballImg, 0, 0, SIZE, SIZE);
    var tint = ballTint();
    if (tint) {
      ctx.save(); ctx.globalCompositeOperation = 'multiply'; ctx.fillStyle = tint;
      ctx.beginPath(); ctx.arc(BALL.x, BALL.y, BALL.r + 2, 0, Math.PI * 2); ctx.fill(); ctx.restore();
    }
    // Logo/text is drawn on its own layer, masked to the print circle, then blended
    // onto the ball in one full-canvas draw. (iPhone Safari can drop a large image
    // drawn with clip + multiply, so the logo vanished near max size on mobile.)
    var LY = layerCanvas, lc = LY.getContext('2d'), drew = false;
    lc.setTransform(1, 0, 0, 1, 0, 0); lc.globalCompositeOperation = 'source-over'; lc.clearRect(0, 0, SIZE, SIZE);
    var L = side === 1 ? S.s1.logo : (S.s2.type === 'logo' ? S.s2.logo : null);
    if (L) {
      var k = L.s * L.kmax, w = L.draw.width * k, hh = L.draw.height * k;
      lc.drawImage(L.draw, C.x + L.o.x - w / 2, C.y + L.o.y - hh / 2, w, hh); drew = true;
    } else if (side === 2 && S.s2.type === 'text') {
      var tx = S.s2.text; if (!tx.g) syncText();
      var kk = tx.s * tx.kmax, col = (COLOURS.filter(function (c) { return c[0] === tx.color; })[0] || COLOURS[0])[1];
      lc.fillStyle = col; lc.textAlign = 'center'; lc.textBaseline = 'middle';
      lc.font = '800 ' + (tx.g.fs * kk) + 'px ' + FONT;
      tx.g.rows.forEach(function (r) { lc.fillText(r.s, C.x + tx.o.x, C.y + tx.o.y + r.y * kk + tx.g.fs * kk * 0.04); });
      drew = true;
    }
    if (drew) {
      lc.globalCompositeOperation = 'destination-in'; lc.fillStyle = '#000';
      lc.beginPath(); lc.arc(C.x, C.y, C.r + 1, 0, Math.PI * 2); lc.fill();
      lc.globalCompositeOperation = 'source-over';
      ctx.save(); ctx.globalCompositeOperation = 'multiply'; ctx.drawImage(LY, 0, 0); ctx.restore();
    }
    if (guides) {
      ctx.save(); ctx.lineWidth = 5; ctx.setLineDash([22, 16]);
      ctx.strokeStyle = S.dragging ? '#a09167' : 'rgba(95,95,95,.85)';
      ctx.beginPath(); ctx.arc(C.x, C.y, C.r + 4, 0, Math.PI * 2); ctx.stroke(); ctx.restore();
    }
  }

  /* ---------- page integration ---------- */
  function currentBallColour() {
    if (!CFG.colourPos) return '';
    var r = document.querySelector('input[data-position="' + CFG.colourPos + '"]:checked');
    if (r) return r.value;
    var v = CFG.variants.filter(function (x) { return String(x.id) === String(currentVariantId()); })[0];
    return v ? v['option' + CFG.colourPos] : '';
  }
  function currentVariantId() {
    var i = document.querySelector('form.js-prod-form-submit input[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return i ? i.value : '';
  }
  function cartForm() {
    return document.querySelector('form.js-prod-form-submit') ||
      $$('form[action*="/cart/add"]').filter(function (f) { return f.querySelector('[type="submit"]'); })[0];
  }
  function optionsBlock() { return document.getElementById('key_options_block'); }
  function labelOf(el) {
    var n = el, i = 0;
    while (n && i < 6) { if (n.innerText && n.innerText.length > 8 && n !== el) return n.innerText; n = n.parentElement; i++; }
    return '';
  }
  // the app option that charges +$5/dozen for the opposite side
  function side2Control() {
    var b = optionsBlock(); if (!b) return null;
    var re = /second pole|2nd pole|second logo|2nd logo|opposite side|other side|deuxi[eè]me logo|c[oô]t[eé] oppos/i;
    var tagged = $$('.cpso-second-pole select', document);
    var sels = tagged.length ? tagged : $$('select', b).filter(function (s) {
      return re.test(labelOf(s).split('\n').slice(0, 3).join(' ')) || $$('option', s).some(function (o) { return re.test(o.text); });
    });
    if (sels.length) {
      var s = sels[0], yes = $$('option', s).filter(function (o) { return /yes|oui|\+\s*\$/i.test(o.text) && !/^\s*no\b/i.test(o.text); })[0];
      var no = $$('option', s).filter(function (o) { return /^\s*(no|non)\b/i.test(o.text) || o.value === ''; })[0];
      if (yes) return { type: 'select', el: s, yes: yes.value, no: no ? no.value : '' };
    }
    var cbs = $$('input[type="checkbox"]', b).filter(function (c) { return re.test(labelOf(c)); });
    if (cbs.length) return { type: 'checkbox', el: cbs[0] };
    return null;
  }
  function setSide2Charge(on) {
    var c = side2Control(); if (!c) return false;
    if (c.type === 'select') { c.el.value = on ? c.yes : c.no; }
    else { c.el.checked = !!on; }
    c.el.dispatchEvent(new Event('input', { bubbles: true }));
    c.el.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function side2ChargeOn() {
    var c = side2Control(); if (!c) return false;
    return c.type === 'select' ? c.el.value === c.yes : c.el.checked;
  }
  function appLogoInput() {
    var b = optionsBlock(); if (!b) return null;
    var f = $$('input[type="file"]', b).filter(function (x) { return !x.closest('.cpso-second-logo-upload'); });
    return f.filter(function (x) { return !x.name; })[0] || f[0] || null;
  }
  function appLogo2Input() { var f = $$('.cpso-second-logo-upload input[type="file"]'); return f.filter(function (x) { return !x.name; })[0] || f[0] || null; } function setFiles(input, files) {
    var dt = new DataTransfer(); files.forEach(function (f) { dt.items.add(f); });
    input.files = dt.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function addProp(form, name, value) {
    var i = h('input', { type: 'hidden', name: 'properties[' + name + ']', class: 'cpso-gbc-prop' }); i.value = value; form.appendChild(i);
  }
  function addFileProp(form, name, file) {
    var i = h('input', { type: 'file', name: 'properties[' + name + ']', class: 'cpso-gbc-prop', hidden: 'hidden', tabindex: '-1', 'aria-hidden': 'true' });
    form.appendChild(i);
    var dt = new DataTransfer(); dt.items.add(file); i.files = dt.files;
  }
  function clearProps() { $$('.cpso-gbc-prop').forEach(function (e) { e.remove(); }); }
  function canvasFile(c, name, type, q) {
    return new Promise(function (res) { c.toBlob(function (b) { res(new File([b], name, { type: type })); }, type, q); });
  }
  function exportPreview(side) {
    var c = document.createElement('canvas'); c.width = SIZE; c.height = SIZE;
    drawSide(c.getContext('2d'), side, false);
    var o = document.createElement('canvas'); o.width = 800; o.height = 800;
    o.getContext('2d').drawImage(c, 0, 0, 800, 800);
    return o;
  }
  function sizeMM(L) {
    if (L.draw) { var k = L.s * L.kmax; return [L.draw.width * k * MM, L.draw.height * k * MM]; }
    var kk = L.s * L.kmax, x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
    (L.pts || []).forEach(function (p) { x0 = Math.min(x0, p.x); x1 = Math.max(x1, p.x); y0 = Math.min(y0, p.y); y1 = Math.max(y1, p.y); });
    return x1 > x0 ? [(x1 - x0) * kk * MM, (y1 - y0) * kk * MM] : [0, 0];
  }
  function fmtMM(a) { var f = function (v) { var s = (Math.round(v * 10) / 10).toFixed(1); return T.pp_centred === 'centré' ? s.replace('.', ',') : s; }; return f(a[0]) + ' × ' + f(a[1]) + ' mm'; }
  function proofQty() { var f = cartForm(), q = f && f.querySelector('input[name="quantity"]'); return q ? q.value : ''; }
  function printProof() {
    if (!S.s1.logo) { toast(T.needs_logo); return; }
    var w = window.open('', '_blank');
    if (!w) { toast(T.pp_popup); return; }
    var mode = approvalMode(), lang = document.documentElement.lang || 'en';
    var p1 = exportProof(1), s2t = S.s2.type, p2 = s2t === 'none' ? '' : exportProof(2);
    var d = new Date(), date = d.toLocaleDateString(lang.slice(0, 2) === 'fr' ? 'fr-CA' : 'en-CA', { year: 'numeric', month: 'long', day: 'numeric' });
    var s2label = s2t === 'none' ? T.pp_blank : s2t === 'logo' ? T.second_logo : T.text;
    function row(k, v) { return v ? '<tr><th>' + esc(k) + '</th><td>' + esc(v) + '</td></tr>' : ''; }
    function side(n, img, rows) { return '<div class="sd"><h3>' + esc(n) + '</h3>' + (img ? '<img src="' + img + '" alt="">' : '<div class="bl">' + esc(T.pp_blank) + '</div>') + '<table>' + rows + '</table></div>'; }
    var L1 = S.s1.logo, r1 = row(T.pp_size, fmtMM(sizeMM(L1))) + row(T.pp_placement, Math.round(L1.s * 100) + '% ' + T.pp_max);
    var r2 = row(T.side2, s2label);
    if (s2t === 'logo' && S.s2.logo) r2 += row(T.pp_size, fmtMM(sizeMM(S.s2.logo))) + row(T.pp_placement, Math.round(S.s2.logo.s * 100) + '% ' + T.pp_max);
    if (s2t === 'text') { var tx = S.s2.text; r2 += row(T.text, textLines(tx).join(' / ')) + row(T.colour, (COLOURS.filter(function (c) { return c[0] === tx.color; })[0] || COLOURS[0])[2]) + row(T.pp_size, fmtMM(sizeMM(tx))); }
    var html = '<!doctype html><html lang="' + esc(lang) + '"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>' + esc(T.pp_title + ' - ' + CFG.title) + '</title><style>' +
      '*{box-sizing:border-box}body{margin:0;font-family:Roboto,Arial,Helvetica,sans-serif;color:#1b1b1b;background:#f5f0e6}' +
      '.pg{max-width:820px;margin:0 auto;background:#fff;padding:28px 32px 26px}' +
      '.hd{display:flex;align-items:center;justify-content:space-between;gap:16px;border-bottom:5px solid #a09167;padding-bottom:16px}.hd img{height:64px}.hd b{font-size:15px;letter-spacing:.06em;text-transform:uppercase;color:#1d3b2a;text-align:right;font-weight:900}' +
      'h1{margin:18px 0 4px;font-size:28px;text-transform:uppercase;color:#1d3b2a;letter-spacing:.02em}h3{margin:0 0 8px;font-size:15px;text-transform:uppercase;letter-spacing:.08em;color:#1d3b2a}' +
      '.meta{width:100%;border-collapse:collapse;margin:10px 0 16px;font-size:14px}.meta th,.meta td{text-align:left;padding:6px 0;border-bottom:1px solid #e3ddcf}.meta th{width:34%;color:#55524b;font-weight:600}' +
      '.sides{display:grid;grid-template-columns:1fr 1fr;gap:18px}.sd{border:1px solid #e3ddcf;border-radius:10px;padding:14px}.sd img{width:100%;display:block;border-radius:8px}.bl{aspect-ratio:1;display:flex;align-items:center;justify-content:center;background:#faf7f0;border-radius:8px;color:#55524b}' +
      '.sd table{width:100%;border-collapse:collapse;font-size:13px;margin-top:8px}.sd th,.sd td{text-align:left;padding:4px 0;vertical-align:top}.sd th{color:#55524b;font-weight:600;width:48%}' +
      '.area{margin-top:16px;background:#1d3b2a;color:#fff;border-radius:10px;padding:14px 18px;font-size:14px;line-height:1.5}.area b{display:block;color:#d9cfae;text-transform:uppercase;letter-spacing:.08em;font-size:12px;margin-bottom:2px}' +
      '.sig{display:grid;grid-template-columns:2fr 1fr;gap:20px;margin-top:22px;font-size:13px;color:#55524b}.sig div{border-top:1px solid #1b1b1b;padding-top:6px}' +
      '.disc{margin-top:16px;font-size:12px;font-style:italic;color:#55524b;line-height:1.5}.ct{margin-top:8px;font-size:13px;color:#1d3b2a;font-weight:700}' +
      '.pb{display:block;margin:16px auto;padding:12px 22px;border:0;border-radius:8px;background:#1d3b2a;color:#fff;font-weight:800;letter-spacing:.06em;text-transform:uppercase;font-size:14px;cursor:pointer}' +
      '@media print{body{background:#fff}.pg{padding:0;max-width:none}.pb{display:none}@page{margin:12mm}}@media(max-width:560px){.sides{grid-template-columns:1fr}.pg{padding:18px}}' +
      '</style></head><body><div class="pg">' +
      '<div class="hd"><img src="' + esc(CFG.cpsoLogo) + '" alt="Canadian Pro Shop Online"><b>' + esc(T.pp_experts) + '</b></div>' +
      '<h1>' + esc(T.pp_title) + '</h1>' +
      '<table class="meta">' + row(T.pp_product, CFG.title) + row(T.pp_ball, currentBallColour()) + row(T.pp_qty, proofQty()) + row(T.pp_date, date) +
      row(T.pp_approval, mode === 'proof' ? T.pp_mode_proof : mode === 'production' ? T.pp_mode_prod : T.pp_mode_none) + '</table>' +
      '<div class="sides">' + side(T.side1, p1, r1) + side(T.side2, p2, r2) + '</div>' +
      '<div class="area"><b>' + esc(T.pp_area_h) + '</b>' + esc(T.pp_area) + '</div>' +
      '<div class="sig"><div>' + esc(T.pp_sign) + '</div><div>' + esc(T.pp_date) + '</div></div>' +
      '<p class="disc">' + esc(T.pp_disc) + '</p><p class="ct">' + esc(T.pp_contact) + '</p>' +
      '</div><button class="pb" onclick="window.print()">' + esc(T.pp_print) + '</button></body></html>';
    w.document.open(); w.document.write(html); w.document.close();
  }
  function exportProof(side) {
    var c = document.createElement('canvas'); c.width = SIZE; c.height = SIZE;
    var keep = S.dragging; S.dragging = false; drawSide(c.getContext('2d'), side, true); S.dragging = keep;
    var o = document.createElement('canvas'); o.width = 700; o.height = 700;
    o.getContext('2d').drawImage(c, 0, 0, 700, 700);
    return o.toDataURL('image/jpeg', 0.9);
  }
  function describe(L) {
    var pct = Math.round(L.s * 100), dx = Math.round(L.o.x / C.r * 100), dy = Math.round(L.o.y / C.r * 100);
    var pos = (Math.abs(dx) < 3 && Math.abs(dy) < 3) ? 'centred' :
      ('moved ' + (dx ? Math.abs(dx) + '% ' + (dx > 0 ? 'right' : 'left') : '') + (dx && dy ? ', ' : '') + (dy ? Math.abs(dy) + '% ' + (dy > 0 ? 'down' : 'up') : ''));
    return pct + '% of max size, ' + pos;
  }

  /* ---------- UI ---------- */
  var openBtn = $('.cpso-gbc-open', root), summary = $('.cpso-gbc-summary', root);
  var modal = $('.cpso-gbc-modal', root); document.body.appendChild(modal);
  var cv = $('.cpso-gbc-canvas', modal), ctx = cv.getContext('2d');
  cv.width = SIZE; cv.height = SIZE;
  var stageHint = $('.cpso-gbc-stagehint', modal);
  var toastEl = $('.cpso-gbc-toast', modal);
  var toastT;
  function toast(m) { toastEl.textContent = m; toastEl.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3600); }

  // colour swatches
  var sw = $('.cpso-gbc-colours', modal);
  COLOURS.forEach(function (c) {
    var b = h('button', { type: 'button', class: 'cpso-gbc-sw', 'data-c': c[0], 'aria-label': c[2], title: c[2] });
    b.innerHTML = '<i style="background:' + c[1] + '"></i><span>' + esc(c[2]) + '</span>';
    b.onclick = function () { S.s2.text.color = c[0]; render(); };
    sw.appendChild(b);
  });

  function logoControls(side) {
    var box = $('[data-logo="' + side + '"]', modal);
    var drop = $('.cpso-gbc-drop', box);
    $$('input[type="file"]', box).forEach(function (input) {
      input.onchange = function () {
        var f = input.files[0]; input.value = '';
        loadLogo(f, function (L) {
          if (side === 1) S.s1.logo = L; else S.s2.logo = L;
          S.side = side; render();
        });
      };
    });
    ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (f) { loadLogo(f, function (L) { if (side === 1) S.s1.logo = L; else S.s2.logo = L; S.side = side; render(); }); } });
    function L() { return side === 1 ? S.s1.logo : S.s2.logo; }
    $('[data-act="bg"]', box).onchange = function () { var l = L(); if (!l) return; l.removeBg = this.checked; buildLogo(l); render(); };
    $('[data-act="inside"]', box).onchange = function () { var l = L(); if (!l) return; l.inside = this.checked; buildLogo(l); render(); };
    var tol = $('[data-act="tol"]', box), tolT;
    tol.oninput = function () { var l = L(); if (!l) return; l.tol = +tol.value; clearTimeout(tolT); tolT = setTimeout(function () { buildLogo(l); render(); }, 60); };
    var size = $('[data-act="size"]', box);
    size.oninput = function () { var l = L(); if (!l) return; l.s = +size.value / 100; l.o = clampOffset(l, l.s, l.o); render(); };
    $('[data-act="centre"]', box).onclick = function () { var l = L(); if (!l) return; l.o = { x: 0, y: 0 }; render(); };
    $('[data-act="max"]', box).onclick = function () { var l = L(); if (!l) return; l.o = { x: 0, y: 0 }; l.s = 1; render(); };
    $('[data-act="remove"]', box).onclick = function () { if (side === 1) S.s1.logo = null; else S.s2.logo = null; render(); };
  }
  logoControls(1); logoControls(2);

  // side 2 type
  $$('input[name="cpso-gbc-s2"]', modal).forEach(function (r) {
    r.onchange = function () { S.s2.type = r.value; S.side = 2; if (r.value === 'text') syncText(); render(); };
  });
  // text lines
  $$('.cpso-gbc-line', modal).forEach(function (inp, i) {
    var cnt = inp.closest('.cpso-gbc-linewrap').querySelector('.cpso-gbc-count');
    inp.addEventListener('input', function () {
      var v = clip17(inp.value);
      if (v !== inp.value) { var pos = inp.selectionStart; inp.value = v; try { inp.setSelectionRange(Math.min(pos, v.length), Math.min(pos, v.length)); } catch (e) { } }
      S.s2.text.lines[i] = inp.value;
      cnt.textContent = graphemes(inp.value).length + '/' + MAXCH;
      syncText(); S.side = 2; render();
    });
  });
  var tsize = $('[data-act="tsize"]', modal);
  tsize.oninput = function () { var tx = S.s2.text; tx.s = +tsize.value / 100; tx.o = clampOffset(tx, tx.s, tx.o); render(); };
  $('[data-act="tcentre"]', modal).onclick = function () { S.s2.text.o = { x: 0, y: 0 }; render(); };

  // tabs
  $$('.cpso-gbc-tab', modal).forEach(function (t) { t.onclick = function () { S.side = +t.dataset.side; render(); }; });

  // dragging + pinch
  var pointers = {}, dragStart = null, pinch = null;
  function toCanvasPt(e) { var r = cv.getBoundingClientRect(); return { x: (e.clientX - r.left) / r.width * SIZE, y: (e.clientY - r.top) / r.height * SIZE }; }
  cv.addEventListener('pointerdown', function (e) {
    var L = activeLayer(); if (!L) return;
    cv.setPointerCapture(e.pointerId); pointers[e.pointerId] = toCanvasPt(e);
    var ids = Object.keys(pointers);
    if (ids.length === 1) { dragStart = { p: pointers[e.pointerId], o: { x: L.o.x, y: L.o.y } }; S.dragging = true; }
    else if (ids.length === 2) { var a = pointers[ids[0]], b = pointers[ids[1]]; pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), s: L.s }; dragStart = null; }
    render(); e.preventDefault();
  });
  cv.addEventListener('pointermove', function (e) {
    if (!pointers[e.pointerId]) return;
    var L = activeLayer(); if (!L) return;
    pointers[e.pointerId] = toCanvasPt(e);
    var ids = Object.keys(pointers);
    if (pinch && ids.length === 2) {
      var a = pointers[ids[0]], b = pointers[ids[1]], d = Math.hypot(a.x - b.x, a.y - b.y);
      L.s = Math.max(0.15, Math.min(1, pinch.s * d / pinch.d)); L.o = clampOffset(L, L.s, L.o);
    } else if (dragStart) {
      var p = pointers[e.pointerId];
      var want = { x: dragStart.o.x + p.x - dragStart.p.x, y: dragStart.o.y + p.y - dragStart.p.y };
      L.o = moveTo(L, want, L.o);
    }
    render(true);
  });
  function endPtr(e) { delete pointers[e.pointerId]; if (!Object.keys(pointers).length) { dragStart = null; pinch = null; S.dragging = false; render(); } }
  cv.addEventListener('pointerup', endPtr); cv.addEventListener('pointercancel', endPtr);
  // keyboard nudge
  cv.addEventListener('keydown', function (e) {
    var L = activeLayer(); if (!L) return;
    var st = e.shiftKey ? 20 : 5, o = { x: L.o.x, y: L.o.y };
    if (e.key === 'ArrowLeft') o.x -= st; else if (e.key === 'ArrowRight') o.x += st;
    else if (e.key === 'ArrowUp') o.y -= st; else if (e.key === 'ArrowDown') o.y += st; else return;
    e.preventDefault(); L.o = moveTo(L, o, L.o); render();
  });

  var thumbs = { 1: $('.cpso-gbc-tab[data-side="1"] canvas', modal), 2: $('.cpso-gbc-tab[data-side="2"] canvas', modal) };
  var revC = { 1: $('.cpso-gbc-rev canvas[data-side="1"]', modal), 2: $('.cpso-gbc-rev canvas[data-side="2"]', modal) };
  [thumbs[1], thumbs[2], revC[1], revC[2]].forEach(function (c) { c.width = 240; c.height = 240; });
  var scratch = document.createElement('canvas'); scratch.width = SIZE; scratch.height = SIZE;
  function paintSmall(target, side) {
    drawSide(scratch.getContext('2d'), side, false);
    var x = target.getContext('2d'); x.clearRect(0, 0, 240, 240); x.drawImage(scratch, 0, 0, 240, 240);
  }

  var raf = 0;
  function render(fast) {
    if (fast) { if (!raf) raf = requestAnimationFrame(function () { raf = 0; drawSide(ctx, S.side, true); }); return; }
    drawSide(ctx, S.side, true);
    var L1 = S.s1.logo, L2 = S.s2.logo, s2t = S.s2.type;
    // tabs
    $$('.cpso-gbc-tab', modal).forEach(function (t) { t.setAttribute('aria-pressed', String(+t.dataset.side === S.side)); });
    paintSmall(thumbs[1], 1); paintSmall(thumbs[2], 2);
    // logo panels
    [1, 2].forEach(function (side) {
      var box = $('[data-logo="' + side + '"]', modal), L = side === 1 ? L1 : L2;
      box.classList.toggle('has-logo', !!L);
      if (L) {
        $('.cpso-gbc-fname', box).textContent = L.file.name;
        var bg = $('[data-act="bg"]', box); bg.checked = L.removeBg && !L.wasTransparent; bg.disabled = L.wasTransparent;
        $('.cpso-gbc-bgnote', box).textContent = L.wasTransparent ? T.already_transparent : T.bg_tip;
        $('[data-act="inside"]', box).checked = L.inside;
        $('.cpso-gbc-bgopts', box).hidden = !L.removeBg || L.wasTransparent;
        $('[data-act="tol"]', box).value = L.tol;
        $('[data-act="size"]', box).value = Math.round(L.s * 100);
      }
    });
    $('[data-logo="2"]', modal).hidden = s2t !== 'logo';
    $('.cpso-gbc-text', modal).hidden = s2t !== 'text';
    $$('input[name="cpso-gbc-s2"]', modal).forEach(function (r) { r.checked = r.value === s2t; });
    $$('.cpso-gbc-sw', modal).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.c === S.s2.text.color)); });
    tsize.value = Math.round(S.s2.text.s * 100);
    // stage hint
    var L = activeLayer();
    if (S.side === 1 && !L1) stageHint.textContent = T.hint_upload;
    else if (S.side === 2 && s2t === 'none') stageHint.textContent = T.hint_blank;
    else if (S.side === 2 && s2t === 'logo' && !L2) stageHint.textContent = T.hint_upload2;
    else if (S.side === 2 && s2t === 'text' && !L) stageHint.textContent = T.hint_text;
    else stageHint.textContent = '';
    stageHint.hidden = !stageHint.textContent;
    $('.cpso-gbc-draghint', modal).hidden = !L;
    $('.cpso-gbc-sidelabel', modal).textContent = S.side === 1 ? T.side1 : T.side2;
    // price + review
    var extra = s2t !== 'none';
    $('.cpso-gbc-extra', modal).hidden = !extra;
    paintSmall(revC[1], 1); paintSmall(revC[2], 2);
    $('.cpso-gbc-rev [data-side="2"]', modal).parentElement.hidden = !extra;
    var lines = [];
    lines.push('<li><b>' + T.side1 + ':</b> ' + (L1 ? esc(T.logo) + (L1.removeBg && !L1.wasTransparent ? ' (' + esc(T.bg_removed) + ')' : '') : '<em class="cpso-gbc-miss">' + esc(T.needs_logo) + '</em>') + '</li>');
    if (s2t === 'none') lines.push('<li><b>' + T.side2 + ':</b> ' + esc(T.blank) + '</li>');
    if (s2t === 'logo') lines.push('<li><b>' + T.side2 + ':</b> ' + (L2 ? esc(T.second_logo) : '<em class="cpso-gbc-miss">' + esc(T.needs_logo2) + '</em>') + ' <span class="cpso-gbc-fee">' + esc(T.fee) + '</span></li>');
    if (s2t === 'text') {
      var tl = textLines(S.s2.text), cn = (COLOURS.filter(function (c) { return c[0] === S.s2.text.color; })[0] || COLOURS[0])[2];
      lines.push('<li><b>' + T.side2 + ':</b> ' + (tl.length ? esc(T.text) + ' “' + tl.map(esc).join(' / ') + '” · ' + esc(cn) : '<em class="cpso-gbc-miss">' + esc(T.needs_text) + '</em>') + ' <span class="cpso-gbc-fee">' + esc(T.fee) + '</span></li>');
    }
    $('.cpso-gbc-sumlist', modal).innerHTML = lines.join('');
    $('.cpso-gbc-ballcol', modal).textContent = currentBallColour() ? (T.ball_colour + ': ' + currentBallColour()) : '';
    var unavailable = !CFG.forceSide2 && !side2Control();
    $('.cpso-gbc-s2na', modal).hidden = !unavailable;
    $$('input[name="cpso-gbc-s2"]', modal).forEach(function (r) { if (r.value !== 'none') r.disabled = unavailable; });
  }

  function problems() {
    var p = [];
    if (!S.s1.logo) p.push(T.needs_logo);
    if (S.s2.type === 'logo' && !S.s2.logo) p.push(T.needs_logo2);
    if (S.s2.type === 'text' && !textLines(S.s2.text).length) p.push(T.needs_text);
    if (!approvalMode()) p.push(T.needs_agree);
    return p;
  }

  function approvalMode() { var r = $('.cpso-gbc-agree:checked', modal); return r ? r.value : ''; }
  function approveLabel() { return approvalMode() === 'proof' ? (T.approve_proof || T.approve) : T.approve; }
  async function approve() {
    var p = problems();
    if (p.length) { toast(p[0]); return; }
    var btn = $('.cpso-gbc-approve', modal); btn.disabled = true; btn.textContent = T.saving;
    try {
      var form = cartForm(); if (!form) throw new Error('no form');
      clearProps();
      var L1 = S.s1.logo, s2t = S.s2.type, files = {}, mode = approvalMode(), pv = mode === 'proof' ? '' : ' (approved)';
      files.p1 = await canvasFile(exportPreview(1), 'golf-ball-side-1-preview.jpg', 'image/jpeg', 0.9);
      addProp(form, 'Golf Ball Customizer', mode === 'proof' ? 'Customer requests an art team proof before production' : 'Design approved by customer');
      addProp(form, 'Proof before production', mode === 'proof' ? 'Yes - send a proof for approval' : 'No - customer approved this preview');
      addFileProp(form, 'Side 1 preview' + pv, files.p1);
      addProp(form, 'Side 1 logo placement', describe(L1));
      if (L1.removeBg && !L1.wasTransparent) addFileProp(form, 'Side 1 logo (background removed)', await canvasFile(L1.draw, 'side-1-logo-no-background.png', 'image/png'));
      if (s2t === 'none') addProp(form, 'Side 2 (opposite side)', 'Blank');
      if (s2t === 'logo') {
        var L2 = S.s2.logo;
        files.p2 = await canvasFile(exportPreview(2), 'golf-ball-side-2-preview.jpg', 'image/jpeg', 0.9);
        addProp(form, 'Side 2 (opposite side)', 'Second logo (+$5.00 per dozen)');
        addFileProp(form, 'Side 2 preview' + pv, files.p2);
        var up2 = appLogo2Input(); if (up2) { setFiles(up2, [L2.file]); S.setLogo2 = true; } else addFileProp(form, 'Side 2 logo (original file)', L2.file);
        if (L2.removeBg && !L2.wasTransparent) addFileProp(form, 'Side 2 logo (background removed)', await canvasFile(L2.draw, 'side-2-logo-no-background.png', 'image/png'));
        addProp(form, 'Side 2 logo placement', describe(L2));
      }
      if (s2t === 'text') {
        var tx = S.s2.text, tl = textLines(tx);
        files.p2 = await canvasFile(exportPreview(2), 'golf-ball-side-2-preview.jpg', 'image/jpeg', 0.9);
        addProp(form, 'Side 2 (opposite side)', 'Text (+$5.00 per dozen)');
        addFileProp(form, 'Side 2 preview' + pv, files.p2);
        tl.forEach(function (s, i) { addProp(form, 'Side 2 text line ' + (i + 1), s); });
        addProp(form, 'Side 2 text colour', tx.color);
      }
      // original logo goes into the existing "Upload your company logo" step
      var up = appLogoInput();
      if (up) { setFiles(up, [L1.file]); S.setLogo = true; }
      else addFileProp(form, 'Side 1 logo (original file)', L1.file);
      if (s2t !== 'none') { setSide2Charge(true); S.setCharge = true; }
      else if (S.setCharge) { setSide2Charge(false); S.setCharge = false; }
      S.approved = { files: files, s2t: s2t, ball: currentBallColour(), mode: mode };
      showSummary();
      close();
      var next = optionsBlock();
      if (next) setTimeout(function () { next.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
    } catch (e) {
      console.error(e); toast(T.err_generic);
    }
    btn.disabled = false; btn.textContent = approveLabel();
  }

  function showSummary() {
    var a = S.approved; if (!a) { summary.hidden = true; summary.innerHTML = ''; openBtn.textContent = T.open; return; }
    var u1 = URL.createObjectURL(a.files.p1), u2 = a.files.p2 ? URL.createObjectURL(a.files.p2) : '';
    var s2 = a.s2t === 'none' ? T.blank : a.s2t === 'logo' ? T.second_logo : (T.text + ' · ' + textLines(S.s2.text).join(' / '));
    summary.innerHTML =
      '<div class="cpso-gbc-sum__head"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>' + esc(a.mode === 'proof' ? (T.approved_title_proof || T.approved_title) : T.approved_title) + '</div>' +
      '<div class="cpso-gbc-sum__imgs"><figure><img src="' + u1 + '" alt="' + esc(T.side1) + '"><figcaption>' + esc(T.side1) + '</figcaption></figure>' +
      (u2 ? '<figure><img src="' + u2 + '" alt="' + esc(T.side2) + '"><figcaption>' + esc(T.side2) + '</figcaption></figure>' : '') + '</div>' +
      '<p class="cpso-gbc-sum__s2"><b>' + esc(T.side2) + ':</b> ' + esc(s2) + (a.s2t !== 'none' ? ' <span class="cpso-gbc-fee">' + esc(T.fee) + '</span>' : '') + '</p>' +
      '<p class="cpso-gbc-sum__next">' + esc(T.next_steps) + '</p>' +
      '<p class="cpso-gbc-sum__warn" hidden>' + esc(T.warn_charge) + '</p>' +
      '<div class="cpso-gbc-sum__btns"><button type="button" class="cpso-gbc-edit">' + esc(T.edit) + '</button><button type="button" class="cpso-gbc-clear">' + esc(T.remove_design) + '</button></div>';
    summary.hidden = false;
    openBtn.textContent = T.open_edit;
    $('.cpso-gbc-edit', summary).onclick = open;
    $('.cpso-gbc-clear', summary).onclick = function () {
      clearProps();
      if (S.setCharge) { setSide2Charge(false); S.setCharge = false; }
      if (S.setLogo) { var up = appLogoInput(); if (up) { try { setFiles(up, []); } catch (e) { } } S.setLogo = false; } if (S.setLogo2) { var up2 = appLogo2Input(); if (up2) { try { setFiles(up2, []); } catch (e) { } } S.setLogo2 = false; }
      S.approved = null; showSummary();
    };
    checkCharge();
  }
  function checkCharge() {
    var w = $('.cpso-gbc-sum__warn', summary); if (!w || !S.approved) return;
    w.hidden = !(S.approved.s2t !== 'none' && side2Control() && !side2ChargeOn());
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('#key_options_block')) setTimeout(checkCharge, 50);
    if (e.target.matches && e.target.matches('input[data-position], select[name="id"]')) setTimeout(function () { if (!modal.hidden) render(); }, 50);
  }, true);

  // safety: if the design needs the second-side fee, make sure it is selected before adding to cart
  document.addEventListener('submit', function (e) {
    var f = cartForm();
    if (e.target !== f || !S.approved) return;
    if (S.approved.s2t !== 'none' && side2Control() && !side2ChargeOn()) {
      e.preventDefault(); e.stopImmediatePropagation(); setSide2Charge(true); checkCharge(); toast(T.warn_charge_fixed);
    }
  }, true);

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    modal.hidden = false; document.documentElement.classList.add('cpso-gbc-lock');
    if (S.s2.type === 'text') syncText();
    render();
    setTimeout(function () { $('.cpso-gbc-close', modal).focus(); }, 30);
  }
  function close() {
    modal.hidden = true; document.documentElement.classList.remove('cpso-gbc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  openBtn.addEventListener('click', open);
  $('.cpso-gbc-close', modal).onclick = close;
  $('.cpso-gbc-cancel', modal).onclick = close;
  $('.cpso-gbc-approve', modal).onclick = approve;
  $('.cpso-gbc-proofbtn', modal).onclick = printProof;
  $$('.cpso-gbc-agree', modal).forEach(function (r) { r.onchange = function () { $('.cpso-gbc-approve', modal).textContent = approveLabel(); }; });
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  ballImg.onload = function () { if (!modal.hidden) render(); };
  root.classList.add('is-ready');
  window.CPSOGolfBallCustomizer = { open: open, state: S, _render: render };
})();
